import { render } from "./JewelleryCard.vue?vue&type=template&id=6f865e30"
import script from "./JewelleryCard.vue?vue&type=script&lang=js"
export * from "./JewelleryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__